module.exports = __webpack_public_path__ + "img/cover4.934788f3.jpg";